import { gqlRequest } from '@mdvip/shared/lib/graphql-client';
import { MyUpcomingPaymentsDocument, type MyUpcomingPaymentsQuery } from '@/graphql/generated/graphql';

export type UpcomingPayment = MyUpcomingPaymentsQuery['myUpcomingPayments'][number];

export async function requestUpcomingPayments(): Promise<UpcomingPayment[]> {
  const data = await gqlRequest(MyUpcomingPaymentsDocument);
  return data.myUpcomingPayments;
}
